export default "__VITE_ASSET__a48105fb__"